<template>
	<div class="container mx-auto">
		<!-- TODO: Add a better Header -->
		<div
			v-if="!isStandalonePage"
			class="flex sm:flex-row flex-col  justify-between text-center mt-4 mb-5 items-center max-w-screen-xl mx-auto">
			<h1 class="text-title-xl grow flex items-center sm:mb-0 mb-4">
				<span class="rounded-full overflow-hidden w-10 h-10 inline-block mr-2"><img
						src="@/assets/favicon-96x96.png" alt=""></span>
				<router-link to="/tattoo">Rendom_Tattoo</router-link>
			</h1>
			<nav class="flex items-center gap-4">
				<button @click="goToTattoo" class="btn-primary" v-if="isAuthenticated">Tattoo</button>
				<button @click="goToCardio" class="btn-primary" v-if="isAuthenticated">Entraînement</button>
				<button @click="logout" class="btn-secondary" v-if="isAuthenticated">Déconnexion</button>
				<button @click="goToLogin" class="btn-primary" v-if="!isAuthenticated">Login</button>
			</nav>
		</div>
		<!-- TODO: Add a page for statistics-->

		<!-- <nav  v-if="$store.state.user">
				<router-link to="/">Home</router-link> |
				<router-link to="/about">About</router-link>
				
			</nav> -->
		<router-view />

	</div>
</template>

<script>
import { onBeforeMount, computed } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
export default {
	setup() {
		const store = useStore();
		const router = useRouter();
		const route = useRoute();
		onBeforeMount(() => {
			store.dispatch('fetchUser');
		});

		// Computed property for checking if the user is authenticated
		const isAuthenticated = computed(() => store.getters.isAuthenticated);
		const isStandalonePage = computed(() => ['Links', 'Home'].includes(route.name));

		// Method to trigger logout
		const logout = () => {
			store.dispatch('logout');
		};

		const goToLogin = () => {
			router.push('/login')
		}
		const goToTattoo = () => {
			router.push('/tattoo');
		};

		const goToCardio = () => {
			router.push('/cardio');
		};

		// Return the values you want to expose to the template
		return {
			isAuthenticated,
			isStandalonePage,
			logout,
			goToTattoo,
			goToCardio,
			goToLogin
		};
	}
}
</script>
